import { useRef } from "react";
import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { useAlturaDaTopbar } from "../../nucleo/alturaDaTopbar";
import { classes } from "../../nucleo/classes";
import { useSaude } from "../../nucleo/saude";
import { VERSAO_DO_FRONT } from "../../nucleo/versao";
import { BuscaGlobal } from "../operacao/BuscaGlobal";
import { MenuLateral } from "./MenuLateral";
import { SinoDeNotificacoes } from "./SinoDeNotificacoes";
import { Topbar } from "./Topbar";
import { Trilha } from "./Trilha";
import type { UsuarioNaTopbar } from "./Topbar";

export interface PropsDaCasca {
  area: string;
  /** `interna` é o backoffice: roda dentro de um iframe do geowork, sem moldura própria. */
  lado: "cliente" | "interna";
  usuario?: UsuarioNaTopbar;
  /** Encerra a sessão. Ausente na área pública e nas telas de erro sem sessão. */
  aoSair?: () => void;
  children?: ReactNode;
}

/**
 * Casca de página: topbar, corpo e rodapé. As rotas entram pelo `Outlet`.
 * A consulta de saúde é feita aqui só para a topbar saber o ambiente; o react-query
 * deduplica com a consulta da página, então continua sendo uma requisição só.
 */
export function Casca({ area, lado, usuario, aoSair, children }: PropsDaCasca) {
  const saude = useSaude();
  const interno = lado === "interna";
  const quadro = useRef<HTMLDivElement>(null);
  useAlturaDaTopbar(quadro);

  return (
    <div
      className={classes(
        "casca min-h-dvh text-tinta p-0",
      )}
    >
      <div className="w-full">
        <div
          ref={quadro}
          className={classes(interno ? "casca__quadro min-h-dvh" : "moldura moldura--cliente")}
        >
          <Topbar
            area={area}
            interno={interno}
            {...(saude.data ? { ambiente: saude.data.ambiente } : {})}
            {...(usuario ? { usuario } : {})}
            {...(aoSair ? { aoSair } : {})}
            {...(interno ? { busca: <BuscaGlobal interno /> } : {})}
            {...(usuario ? { sino: <SinoDeNotificacoes /> } : {})}
            {...(usuario && aoSair
              ? { segurancaPara: interno ? "/admin/seguranca" : "/app/seguranca" }
              : {})}
          />
          <div className="casca__miolo">
            <MenuLateral lado={lado} />
            <main className="corpo min-w-0 flex-1">
              <Trilha />
              {children ?? <Outlet />}
            </main>
          </div>
        </div>

        {interno ? null : (
          <footer className="nota-rodape mt-4 px-1">
            Portal de Implantação GEOvendas · SUS-12304 · fatia F1 — identidade e acesso ·
            bundle{" "}
            <span className="numero-tabular">{VERSAO_DO_FRONT}</span>
          </footer>
        )}
      </div>
    </div>
  );
}
